import { PortalBaseViewController } from '@/views/portal/PortalBaseViewController';
import { PortalResetForgotPasswordController } from '@/views/portal/sign_in/PortalResetForgotPasswordController';
import { TTAPI } from '@/services/TimeTrexClientAPI';
import { IndexViewController } from '@/portal/recruitment/IndexController';
import { ServiceCaller } from '@/services/ServiceCaller';
import { PortalForgotPasswordController } from '@/views/portal/sign_in/PortalForgotPasswordController';
import { RecruitmentPortalNavigation } from '@/portal/recruitment/RecruitmentPortalNavigation';
import 'bootstrap';

export class SignInController extends PortalBaseViewController {
	constructor( options = {} ) {
		_.defaults( options, {
			doing_login: false,
			edit_view_error_ui_dic: {},

			_delegate: null,
			events: {
				'click #forgot_password': 'forgotPasswordClick',
				'submit .signIn-form': 'onLoginSubmit'
			}
		} );

		super( options );
	}

	init( options ) {
		var $this = this;
		$this.recruitment_api = TTAPI.APIRecruitmentAuthentication;
		$this.jobapplicant_api = TTAPI.APIJobApplicantPortal;
		$this.authentication_api = TTAPI.APIAuthentication;
		// var login_data = LocalCacheData.getLoginData();
		var el = Global.loadWidget( 'views/portal/sign_in/SignIn.html' );
		$this.setElement( _.template( el )() );
		$this.user_name = $this.$( '#user_name' );
		$this.password = $this.$( '#password' );
		if ( Global.isSet( options ) && Global.isSet( options._delegate ) ) {
			$this._delegate = options._delegate;
		}
		if ( LocalCacheData.getAllURLArgs().sm === 'ResetPassword' && LocalCacheData.getAllURLArgs().key && LocalCacheData.getAllURLArgs().company_id ) {
			var forgotResetPasswordIntance = new PortalResetForgotPasswordController( {
				callback: function() {
					LocalCacheData.setAllURLArgs( _.omit( LocalCacheData.getAllURLArgs(), 'sm' ) );
					LocalCacheData.setAllURLArgs( _.omit( LocalCacheData.getAllURLArgs(), 'key' ) );

					RecruitmentPortalNavigation.goToPortalView( 'PortalJobVacancy', {}, {
						trigger: false,
						replace: true,
						remove_args: [ 'sm', 'key' ]
					} );
					$this.setLoginTips( $.i18n._( 'Password has been changed successfully, you may now login' ) );
				}
			} );
		} else {
			// $( this.el ).visible();
			$this.render();
		}
		// this.render();
	}

	render() {
		var $this = this;
		LocalCacheData.setSessionID( '' );
		this.password.unbind( 'keydown' ).bind( 'keydown', function( e ) {
			if ( e.keyCode === 13 ) {
				e.preventDefault();
				$this.onLoginBtnClick();
			}
		} );
		if ( LocalCacheData.getAllURLArgs().user_name ) {
			this.user_name.val( LocalCacheData.getAllURLArgs().user_name );
		}
		if ( LocalCacheData.getAllURLArgs().password ) {
			this.password.val( LocalCacheData.getAllURLArgs().password );
		}
		this.showSignInModal();
	}

	showSignInModal() {
		var $this = this;
		$( '#signinModal' ).one( 'shown.bs.modal', function() {
			$this.user_name.trigger( 'focus' );
		} );
		IndexViewController.instance.router.showSignInModal( this.$el, {
			title: $.i18n._( 'Sign In' ),
			actions: [
				{ label: $.i18n._( 'Cancel' ), isClose: true, class: 'btn-default' },
				{
					label: $.i18n._( 'Sign In' ), class: 'btn-primary', callBack: function( e ) {
						$this.onLoginBtnClick();
					}
				}
			]
		} );
	}

	hideSignInModal( callback ) {
		if ( callback ) {
			$( '#signinModal' ).unbind( 'hidden.bs.modal' ).bind( 'hidden.bs.modal', function( e ) {
				callback();
			} );
		}
		IndexViewController.instance.router.hideSignInModal();
	}

	forgotPasswordClick( e ) {
		if ( e && e.preventDefault ) {
			e.preventDefault();
		}
		new PortalForgotPasswordController( {
			render_in_signin_modal: true
		} );
	}

	onLoginSubmit( e ) {
		e.preventDefault();
		this.onLoginBtnClick();
	}

	onLoginBtnClick() {
		var user_name = this.user_name.val();
		var password = this.password.val();
		var $this = this;
		if ( !this.doing_login ) {
			this.doing_login = true;
		} else {
			return;
		}
		//Async call
		this.recruitment_api.Login( user_name, password, {
			onResult: function( e ) {
				$this.onLoginSuccess( e );
				$this.setLocalCacheCompany();
			}, delegate: this
		} );
	}

	setLocalCacheCompany() {
		// set local cache company information this will be used when sending an error report.
		this.authentication_api.getCurrentCompany( {
			onResult: function( current_company_result ) {
				var com_result = current_company_result.getResult();
				LocalCacheData.setCurrentCompany( com_result );
			}
		} );
	}

	onLoginSuccess( e, session_id ) {
		var result;
		var $this = this;
		if ( !session_id ) {
			result = e.getResult();
		} else {
			result = session_id;
		}
		//Clean user preference, since if login to normal UI and than to portal, it's not null.
		LocalCacheData.setLoginUserPreference( null );

		if ( e && !e.isValid() ) {
			LocalCacheData.setSessionID( '' );
			deleteCookie( Global.getSessionIDKey() );

			if ( e.getDetails()[0].hasOwnProperty( 'password' ) ) {
				$this.hideSignInModal();
				$this.password.val( '' );
				IndexViewController.openWizard( 'ResetPasswordWizard', {
					user_name: $this.user_name.val(),
					api_class: TTAPI.APIRecruitmentAuthentication,
					message: e.getDetailsAsString()
				}, function() {
					$this.setLoginTips( $.i18n._( 'Password has been changed successfully, you may now login' ) );
				} );
			} else {
				// TAlertManager.showAlert( e.getDetailsAsString(), 'Error', function() {
				//     password.focus();
				// } );
				this.setErrorTips( e );
			}

			$this.doing_login = false;
		} else {
			this.clearErrorTips();
			ServiceCaller.cancel_all_error = false;

			IndexViewController.setPortalLoginUserData( result, function() {
				IndexViewController.instance.router.headerView.render();
				if ( $this._delegate ) {
					$this._delegate.render();
				}
				$this.hideSignInModal();

				$this.doing_login = false;
			} );
		}
	}

	setLoginTips( message ) {
		if ( typeof this.$( '.alert' )[0] !== 'undefined' ) {
			this.$( '.alert' ).remove();
		}
		var row = Global.loadWidget( 'views/portal/alert/alert.html' );
		this.$( '.signIn-form' ).before( row );
		this.$( '.alert' ).append( '<p>' + message + '</p>' );
		this.showSignInModal();
	}

	setErrorTips(e) {
		var error_list = e.getDetails() ? e.getDetails()[0] : {};
		if (error_list && error_list.hasOwnProperty('error')) {
			error_list = error_list.error;
		}
		for (var key in error_list) {
			if (!error_list.hasOwnProperty(key)) {
				continue;
			}
			var field_obj;
			if (document.getElementById(key)) {
				field_obj = document.getElementById(key);
			}
			if (field_obj) {
				field_obj.classList.add('error-tip');
				var error_string;
				if (_.isArray(error_list[key])) {
					error_string = error_list[key][0];
				} else {
					error_string = error_list[key];
				}
				var myTooltip = new bootstrap.Tooltip(field_obj, {
					title: error_string
				});
				myTooltip.show();
				this.edit_view_error_ui_dic[key] = myTooltip;
			}
		}
	}

	clearErrorTips() {
		Global.removeErrorTips( Object.values( this.edit_view_error_ui_dic ).map( item => item[0] ), true );
		this.edit_view_error_ui_dic = {};
	}

}
